<template>
    <nuxt-link
        v-bind="$attrs"
        class="back-button"
    >
        <BaseIcon
            class="back-button__icon dn-icon--square"
            icon="chevron-left"
        />
        <span class="back-button__text">
            <slot />
        </span>
    </nuxt-link>
</template>

<style lang="less">
.back-button {
    .typography-label-secondary;

    display: flex;
    gap: .5rem;
    align-items: center;

    text-decoration: none;
    transition: color var(--transition-fast);

    &:hover, &:focus {
        color: var(--color-primary);
    }

    &:active {
        color: var(--color-primary-dark);
    }
}

.dn-icon.back-button__icon {
    flex: 0 0 auto;
    font-size: 1.5rem;
    line-height: 0;
    transform: translateX(0);
    transition: transform var(--transition-fast);

    .back-button:hover & {
        transform: translateX(-3px);
    }
}

.back-button__text {
    line-height: 1;
    /** Correct for crappy font */
    position: relative;
    top: 2px;
}
</style>
